import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { GA, WebEngage, DeepBI, PGAD } from "../../integrations";
import styles from "./candidates.m.css";
import { Icon } from "../atoms/icon";
import { get } from "lodash";
import { PAGE_TYPE } from "../../constants";
import { fetchAllCandidatesList } from "../../api";
import { checkAppSlug } from "../utils/utils";
import loader from "../../../assets/images/loader.gif";
import assetify from "@quintype/framework/assetify";
import { Link } from "@quintype/components";

const LoksabhaCandidatesPage = ({ data }) => {
  const [candidatesList, setCandidatesList] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = () => {
      fetchAllCandidatesList()
        .then(res => {
          const resData = get(res, ["data", "items"]);
          setCandidatesList(resData);
          setLoading(false);
        })
        .catch(console.error);
    };
    WebEngage.registerPageView();
    GA.registerPageView(PAGE_TYPE.LOKSABHA_CANDIDATES_PAGE, { collection: data.collection });
    DeepBI.registerPageView({ collection: data.collection });
    PGAD.loadScript();

    fetchData(); // Fetch data initially

    const interval = setInterval(fetchData, 300000); // Fetch data every 5 seconds

    return () => clearInterval(interval); // Cleanup
  }, []);

  let link = "";
  if (checkAppSlug()) {
    link = "?source=app&type=webview";
  }

  const AllLoksabhaCandidates = Object.entries(candidatesList).map(([district, candidates], idx) => (
    <div className={`${styles["other-members-wrapper"]} container`} key={idx}>
      <a
        href={district ? `/election/lok-sabha-election-2024/constituency/${district}${link}?pfrom=candidatespage` : "#"}
        target="_blank"
        rel="noopener noreferrer"
        className={styles["main-title"]}
      >
        <span>{get(candidates[0], ["thokuthi_name"], "")}</span>
        <span className={styles["next-icon"]}>
          <Icon type="slider-next" />
        </span>
      </a>
      <div key={district} className={`${styles["other-members-slider"]}`}>
        {candidates.map((candidate, index) => {
          const candidateImage = get(candidate, ["candidate_image"], "");
          const candidateName = get(candidate, ["candidate_name"], "");
          const partyName = get(candidate, ["party_name"], "");
          const teamName = get(candidate, ["team_name"], "");
          const teamId = get(candidate, ["position"], "");
          const candidateVotes = get(candidate, ["candidate_votes"], "");
          const resultStatus = get(candidate, ["result_status"], "");

          return (
            <div key={`${district}-${index}`} className={`${styles["box-div"]}`}>
              <h1>{teamName}</h1>
              <div className={styles["image-wrapper"]}>
                <img src={candidateImage} alt={candidateName} />
                <div className={styles["badge-wrapper"]}>
                  {teamId && (
                    <div className={styles["badge"]}>
                      {/* <img
                      src="https://media.vikatan.com/vikatan/2024-05/18daf297-6277-4d99-9e70-23245f73999d/num.png"
                      alt="Badge"
                    /> */}
                      <span className={styles["badge-text"]}>{teamId}</span>
                    </div>
                  )}
                  {resultStatus && (
                    <div
                      className={resultStatus === "முன்னிலை" ? styles["result-status-lost"] : styles["result-status"]}
                    >
                      {" "}
                      <div className={styles["status-txt-animation"]}>{resultStatus}</div>
                    </div>
                  )}
                </div>
              </div>

              <h4>
                {candidateName} ({partyName})
              </h4>
              {candidateVotes && (
                <div className={styles["vote-count"]}>
                  {candidateVotes}
                  <span className={styles["vote-count-text"]}>வாக்குகள்</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  ));

  return (
    <div className={styles["candidates-page"]}>
      <div className={`${styles["lok-sabha-election-banner"]} container`}>
        <ul className={styles["breadcrumb-wrapper"]}>
          <li className={`${styles["breadcrumb"]}`}>
            <Link aria-label={`breadcrumb`} href="/">
              முகப்பு
            </Link>
          </li>
          <li className={`${styles["breadcrumb"]}`}>
            <Link aria-label={`breadcrumb`} href="/government-and-politics/election">
              தேர்தல்
            </Link>
          </li>
          <li className={`${styles["breadcrumb"]}`}>
            <Link aria-label={`breadcrumb`} href="/election/lok-sabha-election-2024">
              நாடாளுமன்றத் தேர்தல் 2024
            </Link>
          </li>
          <li className={`${styles["breadcrumb"]}`}>
            <Link
              aria-label={`இங்கு க்ளிக் செய்க`}
              // eslint-disable-next-line max-len
              href="/election/lok-sabha-election-2024/tamilnadu-candidates"
            >
              வேட்பாளர்கள்
            </Link>
          </li>
        </ul>
        <div
          style={{
            backgroundImage:
              "url('https://media.vikatan.com/vikatan/2024-03/2e47da37-5e08-480e-a4af-d8208a3c356c/Election_microsite_mobile_banner.png')"
          }}
          className={`${styles["bg-image-sec"]} hidden-desktop`}
        >
          <h1>
            மக்களவைத் தேர்தல் <span>2024</span> தமிழ்நாடு <br /> வேட்பாளர்கள்
          </h1>
        </div>
        <div
          style={{
            backgroundImage:
              "url('https://media.vikatan.com/vikatan/2024-03/8f1e9b5d-36e3-4471-8902-add433e8dedb/Election_microsite_desktop_banner.png')"
          }}
          className={`${styles["bg-image-sec"]} hidden-mobile`}
        >
          <h1>
            மக்களவைத் தேர்தல் <span>2024</span> தமிழ்நாடு <br /> வேட்பாளர்கள்
          </h1>
        </div>
      </div>

      <div className={styles["other-members-section"]}>
        {loading ? (
          <div className={styles["loader-wrapper"]}>
            <img alt="Loader" src={assetify(loader)} className={styles["loader"]} />
          </div>
        ) : (
          AllLoksabhaCandidates
        )}
      </div>
    </div>
  );
};
export { LoksabhaCandidatesPage };

LoksabhaCandidatesPage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object,
    magazine: PropTypes.array
  }),
  pageType: PropTypes.string,
  config: PropTypes.shape({
    disableAds: PropTypes.bool,
    contentInsightsId: PropTypes.string
  })
};
